module.exports = __webpack_public_path__ + "static/20260616_Fitch_Rating_Report_B-_Outlook_Positive-0f6ab8b6d91bbde70384a159f5244435.pdf";